import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ZapIcon, LockIcon } from 'lucide-react';
const badges = [{
  icon: ShieldCheckIcon,
  label: 'Garantía por\ntu Compra',
  delay: 0
}, {
  icon: ZapIcon,
  label: 'Descarga\nInmediata',
  delay: 0.15
}, {
  icon: LockIcon,
  label: 'Pago\nSeguro',
  delay: 0.3
}];
export function TrustBadges() {
  return <div className="flex flex-wrap items-start justify-center gap-5 md:gap-8 mt-5" data-id="element-118">
      {badges.map((badge, index) => <motion.div key={index} className="flex flex-col items-center gap-1.5 text-mutedBrown" initial={{
      opacity: 0,
      y: 12
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: badge.delay,
      ease: 'easeOut'
    }} data-id="element-119">
          <motion.div className="relative flex items-center justify-center" animate={{
        scale: [1, 1.12, 1],
        filter: ['drop-shadow(0 0 0px rgba(139,34,82,0))', 'drop-shadow(0 0 8px rgba(139,34,82,0.35))', 'drop-shadow(0 0 0px rgba(139,34,82,0))']
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: index * 0.8
      }} data-id="element-120">
            <badge.icon className="w-6 h-6 text-[#8B2252] stroke-[1.5]" data-id="element-121" />
          </motion.div>
          <span className="text-[11px] font-medium text-center leading-tight max-w-[100px] whitespace-pre-line" data-id="element-122">
            {badge.label}
          </span>
        </motion.div>)}
    </div>;
}